import React, {useEffect} from 'react'

import Grid from '@material-ui/core/Grid'
import CardPanel from './CardPanel'

//Service
import DatasetDynamicService from '../../services/DatasetDynamicService';
import PrincipalService from "../../services/PrincipalService";
import {useHistory} from "react-router-dom";


export default (props) => {

  const history = useHistory()

  const [dataSet, setDataSet] = React.useState([])


  const  loadingItems= () =>{

    const initialResponse = PrincipalService.initiaslParam();
    initialResponse.then((resp) => {

      if(resp.data.datasetDynamicId){

        const url = `/pivot/dashboard/${resp.data.id}`;
        history.push(url);

      } else{
        loadindDatasets();
      }

    }).catch((error) => {
      console.error(error)
    })
  }

  /**
   * Carrega os datasets normais sem os dashboards
   */
  const loadindDatasets = () =>{
    const response = DatasetDynamicService.dashboard()
    response
        .then((respUI) => {
          setDataSet(respUI.data)
        })
        .catch((error) => {
          console.error(error)
        })
  }


  useEffect(() => {      
    loadingItems()
  }, [])

  return (    
      <Grid container spacing={2}>          
          {dataSet.map((data, index) => <CardPanel key={index} dataset={data}/>)}                                      
      </Grid>             
  )
}           